import React from 'react';
import { Typography } from '@mui/material';
import { keyframes } from '@mui/system';

// Animation de gradient linéaire
const gradientAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const AnimatedTitle = ({ 
  children, 
  variant = 'h2', 
  sx = {},
  isMobile = false 
}) => {
  return (
    <Typography
      variant={variant}
      sx={{
        fontWeight: 700,
        letterSpacing: '-0.02em',
        background: 'linear-gradient(45deg, #F5F5DC, #E8E8D0, #D4D4AA, #F5F5DC, #E8E8D0)',
        backgroundSize: '400% 400%',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        color: 'transparent',
        animation: `${gradientAnimation} 3s ease infinite`,
        textShadow: 'none',
        filter: 'drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.1))',
        ...sx
      }}
    >
      {children}
    </Typography>
  );
};

export default AnimatedTitle;